export default __webpack_public_path__ + "static/media/checkTrue.4d0f3ce0.svg";